import React, { useState, useEffect } from "react";
import { Cron } from "react-js-cron";
import "react-js-cron/dist/styles.css";
import { DefaultLocale } from "./reactCronLocale.js"

const CronConfig = ({ initialCron = "*/5 * * * *", onCronChange }) => {
  const [cronValue, setCronValue] = useState(initialCron);

  const handleCronChange = (newCron) => {
    setCronValue(newCron);
    onCronChange?.(newCron);
  };

  useEffect(() => {
    setCronValue(initialCron);
  }, [initialCron]);

  return (
    <div style={{marginBottom: '8px', marginTop: '16px'}}>
      <Cron
        value={cronValue}
        setValue={handleCronChange}
        clearButton={false}
        locale={DefaultLocale}
        displayError={false}
      />
    </div>
  );
};

export default CronConfig;
